import { render } from "./MainMore.vue?vue&type=template&id=9748a8c6&scoped=true"
import script from "./MainMore.vue?vue&type=script&lang=js"
export * from "./MainMore.vue?vue&type=script&lang=js"

import "./MainMore.vue?vue&type=style&index=0&id=9748a8c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9748a8c6"]])

export default __exports__